/**
 * @generated SignedSource<<72efa3785fffc79e9659c655fc8f45e3>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type UnitDConnectionDataTable_unitDConnection$data = {
  readonly edges: ReadonlyArray<{
    readonly node: {
      readonly id: string;
      readonly title: string | null;
      readonly unitBTitle: string;
      readonly unitCTitle: string;
    };
  }>;
  readonly " $fragmentType": "UnitDConnectionDataTable_unitDConnection";
};
export type UnitDConnectionDataTable_unitDConnection$key = {
  readonly " $data"?: UnitDConnectionDataTable_unitDConnection$data;
  readonly " $fragmentSpreads": FragmentRefs<"UnitDConnectionDataTable_unitDConnection">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "UnitDConnectionDataTable_unitDConnection",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "UnitDEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "UnitD",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "id",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "unitBTitle",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "unitCTitle",
              "storageKey": null
            },
            {
              "alias": "title",
              "args": null,
              "kind": "ScalarField",
              "name": "description",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "UnitDConnection",
  "abstractKey": null
};

(node as any).hash = "d21ed5131c616e00e47285d353d9eec7";

export default node;
